import axios from 'axios';
import React, { createContext, useEffect, useState } from 'react';
import { API_URL, TOKEN } from '../Constants/constants';
import api from '../Constants/Refresh';

export const AppContext = createContext();

const AppProvider = ({ children }) => {
    const [chatHistory, setChatHistory] = useState([]);
    const [chatId, setChatId] = useState(Number(localStorage.getItem("chatId")) || 0);
    const [botHistory, setBotHistory] = useState(localStorage.getItem('chatbot'));
    useEffect(() => {
        setChatId(0);
        localStorage.removeItem("chatId");
    }, []);
    const getChat = async () => {
        if (!TOKEN) {
            return;
        }

        try {
            const res = await api.get(`${API_URL}/chats`, {
                headers: { Authorization: `Bearer ${TOKEN}` },
                params: {
                    chatbot: botHistory,
                }
            });
            setChatHistory(res.data);
            console.log("bu paidan kelgan habar ", setBotHistory, res.data)
        } catch (err) {
            console.log("Chatlarni olishda xatolik:", err);
        }
    };


    useEffect(() => {
            getChat()
    }, [botHistory])

    const handleSendChat = async (message) => {
        try {
            let currentChatId = chatId;

            if ((!currentChatId || currentChatId === 0) && message.owner === "user") {
                const res = await axios.post(`${API_URL}/chats`, {
                    title: message.content,
                    chatbot: botHistory
                }, {
                    headers: { Authorization: `Bearer ${TOKEN}` },
                });

                currentChatId = res.data.id;
                setChatId(currentChatId);
                localStorage.setItem("chatId", currentChatId);

                setChatHistory((prev) => [
                    { id: res.data.id, title: message.content },
                    ...prev
                ]);
                await getChat();
            }

            // mavjud chatga xabar yuborish
            if (currentChatId && currentChatId !== 0) {
                await axios.post(`${API_URL}/chats/messages/post`, {
                    owner: message.owner,
                    content: message.content,
                    chat_id: currentChatId
                }, {
                    headers: { Authorization: `Bearer ${TOKEN}` },
                });
            }

            return currentChatId;
        } catch (err) {
            console.log("Xatolik:", err);
            return null;
        }
    };

    console.log("chat name", botHistory)

    return (
        <AppContext.Provider value={{
            chatHistory,
            setChatHistory,
            chatId,
            setChatId,
            handleSendChat,
            getChat,
            setBotHistory
        }}>
            {children}
        </AppContext.Provider>
    );
};

export default AppProvider;
